// extracted by mini-css-extract-plugin
module.exports = {"dropList":"HeaderUserMenu_dropList__2HubM","wrapDropListTrigger":"HeaderUserMenu_wrapDropListTrigger__3KE2y","triggerWithLetter":"HeaderUserMenu_triggerWithLetter__o4DdF"};